// types
import type { Components, Theme } from "@mui/material";

export const MuiRadio: Components<Theme>["MuiRadio"] = {};
